import React from 'react'
import { InlineDisplayContent, NumberInput } from '@ztechapps/webui.input'
import { ShowIf } from '@ztechapps/webui.util'
import { useContext } from './Context'
import { PaidAndBalanceAmount } from '../PaidAndBalanceAmount'
import { IsPartialCheckbox } from '../IsPartialCheckbox'
import { useCheckoutContext } from '../../../index'
export const BankPartial = () => {
  const context = useCheckoutContext()
  const hasPartialPayment = context.hasPartialPayments
  const { setAmount, amount, isPartial, errors, balance } = useContext()

  return (
    <ShowIf condition={hasPartialPayment}>
      <hr className={'m-1'} />

      <IsPartialCheckbox />

      <ShowIf condition={isPartial}>
        <PaidAndBalanceAmount />

        <div className={'row'}>
          <div className={'col-md-4'}>
            <InlineDisplayContent label={'Amount'} meta={{ touched: errors?.amount, error: errors?.amount }}>
              <NumberInput
                min={0}
                disabled={balance <= 0}
                value={amount}
                onChange={(e) => {
                  setAmount(e?.target?.value)
                }}
              />
            </InlineDisplayContent>
          </div>
        </div>
      </ShowIf>
    </ShowIf>
  )
}
